import { SCHEMA } from '@vedalib/editor/lib/brand'
import React, { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import 'services/Branding/fieldConfigs/useFieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TestResultFormBrandType, TestResultBrandForms } from './testResultTypes'

export const FONT_FORM_SCHEMA = genSchema(SCHEMA.testResult.font, {
  h2: FONT_FIELDS.h2,
  h3: FONT_FIELDS.h3,
  h4: FONT_FIELDS.h4,
})

const TypographyH2: TestResultFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.h2}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.testResult.tags.percents')}</Typography>
      </BrandGoBack>
    </BrandFormFontBase>
  )
}

const TypographyH3: TestResultFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.h3}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.testResult.tags.result')}</Typography>
      </BrandGoBack>
    </BrandFormFontBase>
  )
}

const TypographyH4: TestResultFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.h4}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.testResult.tags.feedback')}</Typography>
      </BrandGoBack>
    </BrandFormFontBase>
  )
}

const TestResultTypography: TestResultFormBrandType = ({ device, edited, element, setForm }) => {
  const values = useElementFontValues('testResult', device, element?.font)
  const styles = useElementFontCss('testResult', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.h2}
        font='h2'
        onClick={setForm}
        styles={styles.h2}
        values={values.h2}
      >
        {t('elements.testResult.tags.percents')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.h3}
        font='h3'
        onClick={setForm}
        styles={styles.h3}
        values={values.h3}
      >
        {t('elements.testResult.tags.result')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.h4}
        font='h4'
        onClick={setForm}
        styles={styles.h4}
        values={values.h4}
      >
        {t('elements.testResult.tags.feedback')}
      </BrandButtonFont>
    </Padding>
  )
}

const FONTS_FORM_MAP: TestResultBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: TestResultTypography,
  h2: TypographyH2,
  h3: TypographyH3,
  h4: TypographyH4,
}

export default FONTS_FORM_MAP
